import Vue from 'vue';
import { getUrlParam } from '@/utils';
import Store from '@/store';

export const API_NAME = {
  getPageInfo: '/web/template/getPageInfo',
  getInviteeDetail: '/web/template/viewInviteeDetail',
  getInvitedAward: '/web/invitation/addInvitee',
  getRewardTypes: '/web/reward/queryType',
  getRewardData: '/web/reward/query',
  getInviteeCode: '/web/invitation/shareCode',
  postTakeCash: '/web/reward/takeCash',
  getInviteRecord: '/web/getInvitationRecord',
  getCounponDetail: '/web/reward/queryRightDetail',
  getLoginInfo: '/cust/getPageInfo',
  getXlUserMinuCode: '/qrCode/wechat',
  getXLDriverId: '/web/drivers/encrypted_driver_id'
};
const invitationCode = getUrlParam('invitationCode') || null;

const doBasePost = (api, data = {}) => {
  const { locationObj: locationInfo } = Store.state.app;
  const common = {
    type: 0,
    ...(invitationCode ? { invitationCode } : {}),
    code: getUrlParam('code') || null,
    locationInfo
  };
  return Vue.prototype.$request.post(api, {
    ...common,
    ...data,
    locationInfo
  });
};
export const getPageInfo = params => {
  return doBasePost(API_NAME.getPageInfo, {
    ...params
  });
};
export const getInvitee = params => {
  return doBasePost(API_NAME.getInvitedAward, {
    ...params
  });
};
export const getXLDriverId = params => {
  return doBasePost(API_NAME.getXLDriverId, {
    ...params
  });
};
export const getRewardTypes = params => {
  return doBasePost(API_NAME.getRewardTypes, {
    ...params
  });
};

export const getRewardData = params => {
  return doBasePost(API_NAME.getRewardData, {
    ...params
  });
};

export const getInviteeDetail = params => {
  return doBasePost(API_NAME.getInviteeDetail, {
    ...params
  });
};
export const getInviteeCode = params => {
  return doBasePost(API_NAME.getInviteeCode, {
    ...params
  });
};
export const postTakeCash = (params = {}) => {
  return doBasePost(API_NAME.postTakeCash, {
    ...params
  });
};

export const getInviteRecord = params => {
  return doBasePost(API_NAME.getInviteRecord, {
    ...params
  });
};

export const fetchCounponDetail = params => {
  return doBasePost(API_NAME.getCounponDetail, {
    ...params
  });
};
export const getLoginInfo = params => {
  return doBasePost(API_NAME.getLoginInfo, {
    ...params
  });
};
//  获取小拉小程序码
/**
 *
 * @url {*} url  分享url
 * @token token 小程序或者小拉小程序中的token
 * @returns
 */
export const getXlUserMinuCode = params => {
  return doBasePost(API_NAME.getXlUserMinuCode, {
    ...params
  });
};
